import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";

type Payload={
  fileName: string
  appointmentId: string
}
export const useStartAwsScribe = () => {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationKey: ["start aws scrib recording"],
    mutationFn: async ({ fileName, appointmentId }: Payload) => {
      const response = await http.post("/common/aws-scribe", {fileName, appointmentId});
      return response.data;
    },

    onMutate: () => {
      const toastId = toast.loading("Please wait...");
      return { toastId };
    },
    onSuccess: (_data, _variables, context) => {
      const { toastId } = context;
      toast.update(toastId, {
        render: "Sit tight. We are generating your documentation...",
        type: "info",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
        toastId: 'recording-starting-scrib',
      })
      queryClient.invalidateQueries({ queryKey: ['start recording'] as const});
    },

    onError: (error:any, _variables, context) => {
      const toastId = context?.toastId as number

      if (error?.response?.status === 500) {
        toast.update(toastId, {
          render: "Documentation already processed for this appointment",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
          toastId: 'recording-error',
        })

      } else if(axios.isAxiosError(error)){
        toast.update(toastId, {
          render: error?.response?.data?.error || "Error occurred while starting aws scribe recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
          toastId: 'recording-error',
        })
      } else {
        toast.update(toastId, {
          render: error?.message || "An unexpected error occurred while starting aws scribe recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });

      }
    }
  });

  return { startAwsScribe: mutate, ...rest };
}
